import styled from 'styled-components';
import Form from 'components/form';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 40px;
`;

export const QuestionInput = styled(Form.TextInput)`
  height: 60px;
`;
